import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Flex } from "@/eworkitComponents";

import "./_filters-buttons.scss";

const BASE_CLASS = "filters-buttons";

interface IFiltersButtonProps {
  isFilterOpen?: boolean;
  appearance?: "desktop" | "mobile";
  hideClearFilters?: boolean;
  onClearFilterClick?: () => void;
  onFilterOpenClick?: () => void;
  className?: string;
}

const FiltersButtonsComponent: React.FC<IFiltersButtonProps> = ({
  isFilterOpen,
  appearance = "desktop",
  className,
  hideClearFilters,
  onClearFilterClick,
  onFilterOpenClick,
  ...restButtonProps
}) => {
  const { t } = useTranslation("common");

  const wrapperButtonClass = classNames(`${BASE_CLASS}__wrapper`, className, {
    [`${BASE_CLASS}__wrapper-open`]: isFilterOpen,
    [`${BASE_CLASS}__wrapper-closed`]: !isFilterOpen,
  });

  return (
    <Flex
      className={wrapperButtonClass}
      align="center"
      justify={isFilterOpen && appearance === "mobile" ? "space-between" : "center"}
      padding={appearance === "mobile" ? [false, "md"] : undefined}
      innerMargin="md">
      {isFilterOpen && appearance === "mobile" && !hideClearFilters && onClearFilterClick && (
        <Button size="lg" variant="secondary" onClick={onClearFilterClick} display="block" {...restButtonProps}>
          {t("COMPONENTS.FILTERS_CONTAINER.BUTTON_CLEAR_FILTERS_SHORT")}
        </Button>
      )}
      <Button
        className={`${BASE_CLASS}__open-button`}
        size="lg"
        display={isFilterOpen && appearance === "mobile" ? "block" : "inline-block"}
        icon={isFilterOpen ? "close" : "filters"}
        variant={appearance === "mobile" || isFilterOpen ? "primary" : "secondary"}
        onClick={onFilterOpenClick}
        {...restButtonProps}>
        {t(isFilterOpen ? "COMPONENTS.FILTERS_CONTAINER.CLOSE_FILTERS" : "COMPONENTS.FILTERS_CONTAINER.FILTERS")}
      </Button>
    </Flex>
  );
};

export const FiltersButtons = React.memo(FiltersButtonsComponent);
